// Copyright 2020
//   __  __                       _           _     _   _            _ _   _
//  |  \/  | ___   ___  _ __  ___| |__   ___ | |_  | | | | ___  __ _| | |_| |__
//  | |\/| |/ _ \ / _ \| '_ \/ __| '_ \ / _ \| __| | |_| |/ _ \/ _` | | __| '_ \
//  | |  | | (_) | (_) | | | \__ \ | | | (_) | |_  |  _  |  __/ (_| | | |_| | | |
//  |_|  |_|\___/ \___/|_| |_|___/_| |_|\___/ \__| |_| |_|\___|\__,_|_|\__|_| |_|
//
//  All Rights Reserved.
//
// NOTICE:  All information contained herein is, and remains
// the property of Moonshot Health Incorporated and its suppliers,
// if any.  The intellectual and technical concepts contained
// herein are proprietary to Adobe Systems Incorporated
// and its suppliers and may be covered by U.S. and Foreign Patents,
// patents in process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Moonshot Health Incorporated.

// @generated by protoc-gen-es v1.3.3 with parameter "target=js,import_extension=none"
// @generated from file msh/resource/v1/alert.proto (package msh.resource.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";
import { AlertHistory } from "./alert_history_pb";
import { Event } from "./event_pb";
import { User } from "./user_pb";
import { TimeRange } from "../../common/v1/common_pb";

/**
 * @generated from message msh.resource.v1.Alert
 */
export const Alert = proto3.makeMessageType(
  "msh.resource.v1.Alert",
  () => [
    { no: 1, name: "alert_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "creation_time", kind: "message", T: Timestamp },
    { no: 3, name: "status", kind: "enum", T: proto3.getEnumType(Alert_AlertStatus) },
    { no: 4, name: "histories", kind: "message", T: AlertHistory, repeated: true },
    { no: 5, name: "task_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "event", kind: "message", T: Event },
    { no: 7, name: "floor_label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "structure_label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "wandering_task_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "acknowledge_user", kind: "message", T: User },
    { no: 11, name: "device_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * Alert will be created in pending confirmation mode
 * alert in waiting response are considered active alert
 * alert in acknowledge are either by staff or resident/user
 *
 * @generated from enum msh.resource.v1.Alert.AlertStatus
 */
export const Alert_AlertStatus = proto3.makeEnum(
  "msh.resource.v1.Alert.AlertStatus",
  [
    {no: 0, name: "ALERT_STATUS_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "ALERT_STATUS_WAITING_RESPONSE", localName: "WAITING_RESPONSE"},
    {no: 2, name: "ALERT_STATUS_ACKNOWLEDGED", localName: "ACKNOWLEDGED"},
    {no: 3, name: "ALERT_STATUS_PENDING_CONFIRMATION", localName: "PENDING_CONFIRMATION"},
    {no: 4, name: "ALERT_STATUS_ACKNOWLEDGED_BY_RESIDENT", localName: "ACKNOWLEDGED_BY_RESIDENT"},
  ],
);

/**
 * @generated from enum msh.resource.v1.Alert.AlertType
 */
export const Alert_AlertType = proto3.makeEnum(
  "msh.resource.v1.Alert.AlertType",
  [
    {no: 0, name: "ALERT_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "ALERT_TYPE_FALL", localName: "FALL"},
    {no: 2, name: "ALERT_TYPE_WANDERING", localName: "WANDERING"},
  ],
);

/**
 * @generated from message msh.resource.v1.AlertFilter
 */
export const AlertFilter = proto3.makeMessageType(
  "msh.resource.v1.AlertFilter",
  () => [
    { no: 1, name: "time_range", kind: "message", T: TimeRange },
    { no: 2, name: "status", kind: "enum", T: proto3.getEnumType(Alert_AlertStatus) },
    { no: 3, name: "type", kind: "enum", T: proto3.getEnumType(Alert_AlertType) },
  ],
);

